export const notification = (theme) => ({
    backgroundColor: theme.colors?.surface.elevated,
    borderColor: theme.colors?.border.control,
    boxShadow: theme.shadows?.md,
    success: {
        accentColor: theme.colors?.foreground.positive,
        iconColor: theme.colors?.foreground.positive,
    },
    info: {
        accentColor: theme.colors?.foreground.subtle,
        iconColor: theme.colors?.foreground.default,
    },
    warning: {
        accentColor: theme.colors?.foreground.warning,
        iconColor: theme.colors?.foreground.warning,
    },
    danger: {
        accentColor: theme.colors?.foreground.negative,
        iconColor: theme.colors?.foreground.negative,
    },
    progress: {
        accentColor: theme.colors?.foreground.information,
        iconColor: theme.colors?.foreground.information,
    },
    closeIcon: {
        color: theme.colors?.foreground.subtle,
    },
    clearAll: {
        color: theme.colors?.text.basic.secondary,
        hoverColor: theme.colors?.text.basic.primary,
        backgroundColor: theme.colors?.surface.elevated,
        hoverBackgroundColor: theme.colors?.component.hover,
        borderColor: theme.colors?.border.control,
    },
    content: {
        titleColor: theme.colors?.text.basic.primary,
        messageColor: theme.colors?.text.basic.secondary,
    },
});
//# sourceMappingURL=notification.js.map